export const isPending = (task: any) => !['Traité', 'Rejeté'].includes(task.statut_tache);
export function sortRequests<T extends { priority?: string; createdAt?: string; id?: string }>(requests: T[]): T[] {
  const rank: Record<string, number> = { 'Très urgent': 0, Urgent: 1, Normal: 2 };
  return [...requests].sort((a, b) => (rank[a.priority || ''] ?? 2) - (rank[b.priority || ''] ?? 2)
    || new Date(a.createdAt || 0).getTime() - new Date(b.createdAt || 0).getTime()
    || (a.id || '').localeCompare(b.id || ''));
}
